<template>
  <div class="container-events">

    <div ref="index" class="row">
      <div class="col-md-4">
        <input
          class="input form-control"
          v-model="query.generic"
          @keypress.enter="find()"
          placeholder="Pesquisar por Conteúdo"
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <button
        class="col-md-2 ml-2 btn-sm btn-outline"
        style="min-height:40px;"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>

      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query"
          :filters="badgesFilters"
          :amount-changed="updateNumberOfBadges"
          @clearBadge="find()"
          @clearAllBadges="find()"
        />
      </div>
    </div>

    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label for="event-user-email">Usuário</label>
          <Select2
            v-model="query.userEmail"
            id="event-user-email"
            :options="filterUserEmail"
          />
        </div>

        <div class="col-md-4">
          <label for="event-action">Ação</label>
          <Select2
            v-model="query.action"
            id="event-action"
            :options="filterAction"
          />
        </div>

        <div class="col-md-4">
          <label for="event-record-type">Registro</label>
          <Select2
            v-model="query.recordType"
            id="event-record-type"
            :options="filterRecordType"
          />
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4">
          <label for="event-start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="event-start-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="event-end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="event-end-date" class="form-control">
        </div>
      </div>
    </template>
    <hr>

    <button
      class="btn btn-primary mr-1"
      @click="exportXLSX()"
      :disabled="!meta.totalCount"
    >
      Exportar relatório
    </button>

    <div class="row mt-4">
      <div class="col-md-12">
        <small>
          {{ infoTotalModels }}
        </small>

        <button
          v-if="meta.totalCount > 0"
          class="btn btn-outline ml-3 mb-1"
          :class="{ 'btn-outline-active': checkAll }"
          @click="changeCheck({checkAll: !checkAll, sources: events})"
        >
          {{ !checkAll ? 'Selecionar todos' : 'Desmarcar todos' }} ({{ meta.totalCount || 'Calculando' }})
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">

        <table class="table table-borderless table-border table-align table-h51">
          <thead>
          <tr>
            <th style="width: 40px">
              <BkpsCheckBox :value="checkAllRow" @input="changeCheckAllRow"/>
            </th>
            <th>Ação</th>
            <th style="width: 130px">Data</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="event in events" :key="event.id">
            <td>
              <BkpsCheckBox v-model="event.checked" @input="changeCheckRow"/>
            </td>
            <td>
              <span v-html="event.htmlMessage"></span>
              <span v-if="event.pretenderEmail"> (via {{ event.pretenderEmail }})</span>
              <button
                v-if="event.changes && event.changes.length > 0"
                class="btn btn-link p-0 ml-1"
                @click="showDetails(event)"
              >
                Clique para ver detalhes
              </button>
            </td>
            <td>
              <strong>{{ event.createdAt | date }}</strong>
              <br>
              <strong>{{ event.createdAt | hour }}</strong>
            </td>
          </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>

      </div>
    </div>

    <DetailModal v-model="showDetailModal" :event="eventDetailed"/>

  </div>
</template>

<script>
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
  import CheckedModels from '@/mixins/CheckedModels'
  import DetailModal from '@/components/event/DetailModal'
  import GetAccount from '@/mixins/GetAccount'
  import ModelMapper from '@/mixins/ModelMapper'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import Select2 from '@/components/shares/Select2'
  import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
  import { Filter } from '@/models/filter'

  export default {
    components: {
      BadgeFilters, BkpsCheckBox, ChevronDownIcon, DetailModal,
      Pagination, SearchIcon, Select2
    },
    computed: {
      badgesFilters() {
        return [
          this.filterAction, this.filterEndDate, this.filterRecordType,
          this.filterStartDate, this.filterUserEmail
        ].filter(Boolean)
      },
      events() {
        return this.getModels || []
      }
    },
    created() {
      this.query.accountId = this.getAccount.id
      this.query.system = false
      this.$set(this.query, 'generic', '')
      this.$set(this.query, 'userEmail', [])
      this.$set(this.query, 'action', [])
      this.$set(this.query, 'recordType', [])
      this.$set(this.query, 'startDate', '')
      this.$set(this.query, 'endDate', '')
      this.loadFilterOptions()
      this.find()
    },
    data() {
      return {
        eventDetailed: null,
        filterAction: null,
        filterEndDate: new Filter({
          key: 'endDate',
          label: 'Data final',
          type: 'date'
        }),
        filterRecordType: null,
        filterStartDate: new Filter({
          key: 'startDate',
          label: 'Data inicial',
          type: 'date'
        }),
        filterUserEmail: null,
        nameModel: 'Event',
        showDetailModal: false
      }
    },
    methods: {
      applyPeriod(params) {
        if (!params.q)
          return

        if (this.query.startDate)
          params.q.start_date = `${this.query.startDate}T00:00:00`

        if (this.query.endDate)
          params.q.end_date = `${this.query.endDate}T23:59:59`
      },
      changeCheckAllRow(value) {
        this.changeCheck({ checkAllRow: value, sources: this.events })
      },
      changeCheckRow() {
        this.changeCheck({ sources: this.events })
      },
      exportXLSX() {
        const ids = this.events.filter(e => e.checked).map(e => e.id)
        let params
        let amount

        if (this.checkAll || ids.length === 0) {
          params = this.buildParams()
          this.applyPeriod(params)
          amount = this.meta.totalCount
        } else {
          params = { q: { id: ids } }
          amount = ids.length
        }

        const message = amount === 1 ?
          'Exportar a ação selecionada?' :
          `Exportar as ${amount} ações?`

        if (!confirm(message))
          return

        this.openGlobalLoad()
        this.axios.get('events/report', { params })
          .then(response => {
            if (response.data)
              this.$parse.downloadByLink(response.data)
            else
              this.$notify.add(response.meta.notice)
          })
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeGlobalLoad())
      },
      find() {
        this.search()
      },
      loadFilterOptions() {
        this.axios.get('events/filter_options')
          .then(response => {
            const data = response.data || {}

            this.filterUserEmail = new Filter({
              key: 'userEmail',
              label: 'Usuário',
              table: (data.users || []).map(email => ({ label: email, value: email }))
            })
            this.filterAction = new Filter({
              key: 'action',
              label: 'Ação',
              table: data.actions || []
            })
            this.filterRecordType = new Filter({
              key: 'recordType',
              label: 'Registro',
              table: data.record_types || []
            })
          })
          .catch(e => this.$notify.addError(e))
      },
      pagination(page) {
        this.params.page = page
        this.search(true)
      },
      search(pagination) {
        this.asyncTemplateSelect({
          pagination: pagination,
          before: ({ params }) => this.applyPeriod(params)
        })
      },
      showDetails(event) {
        this.eventDetailed = event
        this.showDetailModal = true
      }
    },
    mixins: [CheckedModels, GetAccount, ModelMapper],
    name: 'Container'
  }
</script>

<style scoped>

.container-events {
  position: relative;
}

</style>
